import { Button, Modal } from "@mui/material";

const ChangePasswordInfo = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        zIndex: 9999,
        outline: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          maxWidth: "690px",
          width: "100%",
          overflow: "auto",
          borderRadius: "var(--wrapperBorderRadius)",
          outline: "none",
          maxHeight: "90vh",
          padding: "20px",
        }}
      >
        {/* <figure
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "var(--pastelBlue)",
          }}
        >
          <img
            src="/images/heros/heros.png"
            alt="Hadenka"
            style={{ width: "100%" }}
          />
        </figure> */}
        <div
          style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap)",
          }}
        >

          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu süre zarfı içerisinde LÜTFEN ETSY BAĞLANTINIZI IYZISHIP ile koparmayınız.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bilgilerinize
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu vesileyle Kurban Bayramınızın Mübarek olmasını dileriz. Hayırlı Bayramlar…
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Bilgilerinize…
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Saygılarımızla,
          </p> */}
          <h2
            style={{
              fontSize: "22px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            eBay Satıcılarına Müjde! 📢
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            hadenka’nin ücretsiz eBay entegrasyonu ile artık satış sonrası süreçleriniz zahmetsiz.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Tek tıkla tüm siparişlerinizi senkronize edin, kargo süreçlerinizi hızlandırın ve operasyonel yükünüzü hafifletin. 📦
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Ebay mağazanızı entegre etmenizi bekliyoruz. Bol satışlar dileriz!
          </p>
          <h2
            style={{
              fontSize: "22px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            Değerli hadenka Üyelerimiz
          </h2>
          {/* <h2
            style={{
              fontSize: "22px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            SİZLER İÇİN PANELİMİZDE BİRKAÇ GÜNCELLEME YAPTIK :)
          </h2> */}
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Entegrasyonla ilgili herhangi bir sorun yaşamanız durumunda, lütfen destek hattımızla iletişime geçmeden hadenka ile olan API bağlantınızı sonlandırmayınız.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            BOL SATIŞLAR! 🚀
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Hadenka
          </p>
          <Button className="iyzi-button-blue" onClick={handleClose}>
            Tamam
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangePasswordInfo;
